module.exports = __webpack_public_path__ + "03_short_beige.dce6395e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_short_beige.png
// module id = e4qs
// module chunks = 0